import { Box, Button, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import React, { useContext, useMemo } from 'react'
import { ThemeContext } from "../../context/ThemeContext";
import { TableVirtuoso } from 'react-virtuoso'

import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from 'react-i18next';
import '../../App.scss'
import { useDragContext } from '../../context/DragContext';

const WatchlistTable = ({ columns = [], data = [], loading, handleRowClick, onRowDoubleClick, cellStyleMapper = {}, onRowRightClick, activeRowId, onHeaderClick, watchlistHeight = 100, handleShowAllSymbols }) => {
    // const symbols = useSymbolPrices();
    const { darkMode } = useContext(ThemeContext);
    const { symbols } = useSelector(state => state?.watchlist)
    const { userDetail } = useSelector(state => state.user);
    const { t } = useTranslation()
    const id = userDetail?.id;
    const storedHiddenSymbols = JSON.parse(localStorage.getItem(`hiddenSymbols_${id}`)) || [];
    const { globalSymbolID } = useSelector(state => state.globalSymbol)
    const { startDrag, endDrag } = useDragContext();

    const filteredSymbols = useMemo(() => {
        return Object.values(symbols).filter(symbol =>
            symbol.isVisible && symbol.isUsed &&
            !storedHiddenSymbols.includes(symbol.id)
        );
    }, [symbols, storedHiddenSymbols]);

    const VirtuosoTableComponents = {
        Table: (props) => (
            <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
        ),
        TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
        TableRow: React.forwardRef((props, ref) => <TableRow {...props} ref={ref} />),
        TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
    };

    const fixedHeaderContent = () => (
        <TableRow >
            {columns.map((col, index) => {
                const isSticky = index === 0;
                return (
                    <TableCell key={index} onContextMenu={onHeaderClick} style={{ width: col?.width }} sx={{ fontWeight: "bold", p: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', backgroundColor: darkMode ? "var(--background-color)" : 'var(--white)', ...(isSticky && { position: 'sticky', left: 0, zIndex: 4, backgroundColor: darkMode ? "var(--background-color)" : '#fff', }), }}>
                        {col.title}
                    </TableCell>
                );
            })}
        </TableRow>
    );

    const Row = useMemo(() => (index, row) => {
        const isActiveRow = row.id === globalSymbolID;
        return (
            <>
                {columns.map((col, colIndex) => {
                    const alignStyle = {};
                    const isSticky = colIndex === 0;
                    return (
                        <TableCell sx={{
                            border: 'none', fontSize: '0.875rem', ...alignStyle, position: isSticky ? 'sticky' : 'static', left: isSticky ? 0 : 'auto', backgroundColor: isActiveRow ? (darkMode ? 'var(--highlightDark)' : 'var(--highlightLight)') : (isSticky ? (darkMode ? 'var(--background-color)' : '#fff') : 'inherit'), whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleRowClick && handleRowClick(row); }}
                            onDoubleClick={() => { onRowDoubleClick && onRowDoubleClick(row); }}
                            onContextMenu={(e) => { e.preventDefault(); e.stopPropagation(); onRowRightClick && onRowRightClick(e, row); }}
                            draggable
                            onDragStart={e => startDrag(e, row)}
                            onDragEnd={endDrag}
                            key={colIndex} style={{ padding: '10px' }}>
                            {col?.render ? col.render(row?.[col?.dataIndex] || "", row, index) : row?.[col.dataIndex] || ""}
                        </TableCell>
                    );
                })}
            </>
        );
    }, [columns]);
    const addImg = '/cuate.png'
    return (
        !filteredSymbols.length ? <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", cursor: "pointer", color: darkMode ? "white" : "black", fontSize: 14, fontWeight: 500, m: 0, height: "100%", }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", opacity: 0.4 }}>
                <img alt='alldflsdg' src={addImg} style={{ width: "8rem" }} />
            </Box>
            <Box sx={{ mb: 1, mt: '-2rem' }}>
                <span>{t('youHaveNoSelectedSymbols')}</span>
            </Box>
            <Button onClick={handleShowAllSymbols} variant="contained" size="small" startIcon={<AddIcon />} sx={{ fontWeight: 500, fontSize: 14, px: 2, }}>{t('Pleaseaddsymbols')}</Button>
        </Box> :
            <Paper style={{ height: `calc(100% - 48px)`, width: '100%', }} >
                <TableVirtuoso data={filteredSymbols} components={VirtuosoTableComponents} fixedHeaderContent={fixedHeaderContent} itemContent={Row} height={20} style={{ backgroundColor: darkMode ? "#151924" : "#fff", }}>
                </TableVirtuoso>
            </Paper>
    )
}

export default WatchlistTable